import React, { useEffect, useState } from 'react'
// import { httpsCallable } from 'firebase/functions'
import { getIdToken, onAuthStateChanged } from 'firebase/auth'
import { addDoc, collection, doc, serverTimestamp, updateDoc } from 'firebase/firestore'
// import IpContext from './context'
// import useFunctions from '../../hooks/useFunctions'
import useFirestore from '../../hooks/useFirestore'
import useAuth from '../../hooks/useAuth'
import useUserProfile from '../../hooks/useUserProfile'
import { USER_LOG_IN } from '../../constants/logs'

const storageKey = 'portaly:loggedIn'

const IpProvider = ({ children }) => {
  // const functions = useFunctions()
  const firestore = useFirestore()
  const auth = useAuth()
  // const [isLoading, setIsLoading] = useState()
  // const [isLoaded, setIsLoaded] = useState()
  // const [ip, setIp] = useState('')
  const profileData = useUserProfile()
  // useEffect(() => {
  //   setIsLoading(true)
  //   setIsLoaded(false)
  //   if (functions) {
  //     const getIp = httpsCallable(functions, 'getIp')
  //     getIp().then(({ data }) => {
  //       setIsLoading(false)
  //       setIsLoaded(true)
  //       setIp(data.ip)
  //     }).catch(() => {
  //       setIsLoading(false)
  //     })
  //   }
  // }, [functions])
  useEffect(() => {
    if (auth) {
      onAuthStateChanged(auth, (user) => {
        if (user) {
          if (typeof window.gtag === 'function') {
            window.gtag('set', { 'user_id': user.uid });
            window.gtag("event", "login");

          }
          if (typeof window.heap === 'function') {
            window.heap.identify(user.uid);
          }
          updateDoc(doc(firestore, 'users', user.uid), { lastLoginAt: +user.metadata.lastLoginAt })
          if (!sessionStorage.getItem(storageKey)) {
            addDoc(collection(firestore, 'logs'), {
              type: USER_LOG_IN,
              timestamp: serverTimestamp(),
              uid: user.uid,
            })
            sessionStorage.setItem(storageKey, true)
          }
          getIdToken(user, true).then(token => {
            sessionStorage.setItem('portaly:firebaseToken', token)
          })
        }
      });
    }
  }, [auth, firestore])
  useEffect(() => {
    if (profileData && profileData.admin) {
      if (typeof window.gtag === 'function') {
        window.gtag('set', 'user_properties', {
          role: 'admin',
        });
      }
      if (typeof window.heap === 'function') {
        window.heap.addUserProperties({
          'Role': 'Admin',
        });
      }
    }
  }, [profileData])
  return children
}

export default IpProvider
